import React from 'react';
import { Alert, AlertProps } from '@mui/material';

interface MUIAlertProps {
  severity?: 'success' | 'info' | 'warning' | 'error';
  children: React.ReactNode;
  sx?: AlertProps['sx'];
}

const MUIAlert: React.FC<MUIAlertProps> = ({ severity = 'info', children, sx }) => (
  <Alert severity={severity} sx={{ mb: 2, padding: '6px 16px !important', ...sx }}>
    {children}
  </Alert>
);

export default MUIAlert;
